import React, { useState, useEffect } from 'react';

import Pagination from "../../../../shared/pagination";
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';

import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';

import UserInvite from "../../../reunioesInviteCard";

import UseStyle from "../../../useStyles";

import { cadastrarConvidado, removerConvidado, getConvidados, getPaginaDeConslheirosDisponíveis } from '../../../../../services/reuniao/ReuniaoService';

const ReuniaoAbaConvidados = (props) => {

  const {
    handleStepper,
    dados,
    updateDados,
    isEditar,
    isVisualizar,
    history,
  } = props;

  const [conselheiros, setConselheiros] = useState([]);
  const [paginacaoConselheiro, setPaginacaoConselheiro] = useState({ pagina: 0, totalDePaginas: 0 });
  const [filtro, setFiltro] = useState({ nome: '', entidade: '' });

  const [usuariosAdd, setUsuariosAdd] = useState([]);

  const [convidados, setConvidados] = useState([]);

  const [listUsuariosAdd, setListUsuariosAdd] = useState([]);

  const classes = UseStyle();

  const getConselheiros = async (page) => {
    try {
      const response = await getPaginaDeConslheirosDisponíveis(dados.id, page, filtro);
      const { data } = response;
      const { content, totalPages } = data;
      setConselheiros(content);
      setPaginacaoConselheiro({ pagina: page, totalDePaginas: totalPages })
    } catch (e) {

    }
  };

  const handleRemove = async (index) => {
    let aux = usuariosAdd.map(e => e);

    if (aux[index] && aux[index].usuarioPerfil && dados.id) {
      await removerConvidado(dados.id, aux[index].usuarioPerfil.id);
      aux.splice(index, 1);
      setUsuariosAdd(aux);
      setListUsuariosAdd(usuariosAdd.map((value, index) => (
        <div style={{ marginBottom: 24, marginRight: 24 }}>
          <UserInvite adicionado={true} removeFunction={() => handleRemove(index)} user={value} key={index} />
        </div>
      )));
      updateDados({ ...dados, usuariosConvidados: aux });
      getConselheiros(paginacaoConselheiro.pagina);
    }
  }

  const handleAdd = (index) => {

    if (conselheiros[index] && conselheiros[index].idUsuarioPerfil && dados.id) {
      let formData = new FormData();
      formData.append("idReuniao", dados.id);
      formData.append("idConvidado", conselheiros[index].idUsuarioPerfil);
      cadastrarConvidado(formData).then((response) => {
        if (response && response.status === 200) {
          const { data } = response;
          let aux = usuariosAdd;
          conselheiros[index].idConvidado = data;
          aux.push(conselheiros[index]);
          conselheiros.splice(index, 1);
          setUsuariosAdd(aux);
          setListUsuariosAdd(usuariosAdd.map((value, index) => (
            <div style={{ marginBottom: 24, marginRight: 24 }}>
              <UserInvite adicionado={true} removeFunction={() => handleRemove(index)} user={value} key={index} />
            </div>
          )));
          updateDados({ ...dados, usuariosConvidados: usuariosAdd });
          console.log(dados.usuariosConvidados);
          inicio();
        }
      });
    }
  }

  const finaliza = () => {
    history.push('/reunioes');
  }

  const proximaAba = (skip = false) => {
    if (!skip) {
      handleStepper(4);
    }else {
      history.push(`/reuniao/${dados.id}/visualizar`);
    }
  }

  const inicio = () => {
    if (dados && dados.id) {
      getConvidados(dados.id).then((response) => {
        if (response && response.status === 200) {
          const { data } = response;
          setUsuariosAdd(data);
          setListUsuariosAdd(data.map((value, index) => (
            <div style={{ marginBottom: 24, marginRight: 24 }}>
              <UserInvite adicionado={true} removeFunction={() => handleRemove(index)} user={value} key={index} />
            </div>
          )));
          updateDados({ ...dados, usuariosConvidados: data });
        }
      });
    }
  }

  useEffect(() => {
    inicio();
    getConselheiros(paginacaoConselheiro.pagina);
  }, [])

  return (
    <>
      <div style={{ marginTop: 150, padding: '0 24px' }}>
        <div style={{ borderBottom: '1px solid #dfdfe6', paddingBottom: 40 }}>
          <div style={{ marginBottom: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
              <Typography className={classes.tituloAba}>4. Convidados</Typography>
              {!isEditar && <Button onClick={finaliza} variant="contained">Criar reunião</Button>}
              {isEditar &&
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                  <Button onClick={() => proximaAba(true)} variant="contained">Finalizar</Button>
                  <Button onClick={() => proximaAba()} variant="contained">Próximo</Button>
                </div>}
            </div>
            <Typography className={classes.subTituloAba}>CONVIDADOS SELECIONADOS</Typography>
            <Typography className={classes.subTituloSpan}>Membros que compõem a reunião</Typography>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {usuariosAdd.map((value, index) => (
              <div style={{ marginBottom: 24, marginRight: 24 }}>
                <UserInvite adicionado={true} removeFunction={() => handleRemove(index)} user={value} key={index} />
              </div>
            ))}
          </div>
        </div>
        {!isVisualizar &&
          <div>
            <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <Typography className={classes.subTituloAba}>MEMBROS DOS CONSELHO</Typography>
                <Typography className={classes.subTituloSpan}>Selecione os membros a serem convocados para a reunião</Typography>
                <Hidden smUp>
                  <TextField
                    fullWidth
                    value={filtro.nome}
                    onChange={(e) => setFiltro({ ...filtro, nome: e.target.value })}
                    variant='outlined'
                    InputLabelProps={{ shrink: 'true' }}
                    placeholder="digite sua pesquisa"
                    InputProps={{
                      disableUnderline: true,
                      startAdornment: (
                        <InputAdornment onClick={(e) => console.log(e.target)} position="start">
                          <SearchIcon style={{ color: '#0B4FD9', cursor: 'pointer' }} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment onClick={() => setFiltro({ ...filtro, nome: '' })} position="end">
                          <CloseIcon style={{ color: '#5e6784', cursor: 'pointer' }} />
                        </InputAdornment>
                      ),
                    }} />
                </Hidden>
              </div>
              <Hidden xsDown>
                <div style={{ marginTop: 24 }}>
                  <TextField
                    fullWidth
                    value={filtro.nome}
                    onChange={(e) => setFiltro({ ...filtro, nome: e.target.value })}
                    variant='outlined'
                    InputLabelProps={{ shrink: 'true' }}
                    placeholder="digite sua pesquisa"
                    InputProps={{
                      disableUnderline: true,
                      startAdornment: (
                        <InputAdornment onClick={(e) => console.log(e.target)} position="start">
                          <SearchIcon style={{ color: '#0B4FD9', cursor: 'pointer' }} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment onClick={() => setFiltro({ ...filtro, nome: '' })} position="end">
                          <CloseIcon style={{ color: '#5e6784', cursor: 'pointer' }} />
                        </InputAdornment>
                      ),
                    }} />
                </div>
              </Hidden>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {conselheiros.map((value, index) => (
                <div style={{ marginBottom: 24, marginRight: 24 }}>
                  <UserInvite addFunction={() => handleAdd(index)} user={value} key={index} />
                </div>
              ))}
            </div>
            <div style={{ marginBottom: 24 }}>
              <Pagination
                pagina={paginacaoConselheiro.pagina}
                tamanhoDaPagina={8}
                totalDePaginas={paginacaoConselheiro.totalDePaginas}
                onChangePage={getConselheiros}
              />
            </div>
          </div>}
      </div>
    </>
  );
}

export default ReuniaoAbaConvidados;
